"use strict";
var Observable_1 = require('../../Observable');
var empty_1 = require('../../observable/empty');
Observable_1.Observable.empty = empty_1.empty;
//# sourceMappingURL=empty.js.map


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src4078178155/src/~/rxjs/add/observable/empty.js
// module id = hbO+
// module chunks = 6